/**
 * Grafik serilerinde "ölçüm yok" durumunu ele almak için yardımcılar.
 *
 * Backend, o gün için ölçüm yoksa artık `null` döndürüyor (önceden sıfıra bölme
 * sonucu "NaN" string'i dönüyordu ve grafik hiç çizilemiyordu — bkz. M-19).
 * `null` teknik olarak doğru ama müşteri boş bir grafik görünce sistemin bozuk
 * olduğunu düşünüyor. Bu yüzden:
 *   - hiç ölçüm yoksa grafiğin yerine açık bir mesaj gösteriyoruz
 *   - bazı günler eksikse o noktalar boşluk kalıyor, ipucunda "Ölçüm yok" yazıyor
 */

export const NO_DATA_TEXT = 'Seçilen aralıkta ölçüm yok'
export const NO_DATA_POINT_TEXT = 'Ölçüm yok'

/** Değeri sayıya çevirir; ölçüm yoksa null döner. "NaN" string'i de ölçümsüz sayılır. */
export function toChartValue(value: any): number | null {
  if (value === null || value === undefined) return null
  const text = String(value).trim()
  if (text === '' || text.toLowerCase() === 'nan') return null
  const parsed = Number(text)
  return Number.isFinite(parsed) ? parsed : null
}

/** Bir seriyi grafiğe verilebilir hale getirir: ölçümsüz noktalar null olur. */
export function toChartSeries(values: any): (number | null)[] {
  if (!Array.isArray(values)) return []
  return values.map(toChartValue)
}

/** Seride en az bir gerçek ölçüm var mı. */
export function hasAnyValue(values: any): boolean {
  return toChartSeries(values).some((v) => v !== null)
}

/**
 * ApexCharts'ta ölçümsüz noktanın ipucunda "Ölçüm yok" yazdırır.
 * Grafik seçeneklerinde tooltip.y.formatter olarak kullanılır.
 */
export function chartValueFormatter(suffix: string) {
  return (value: number | null | undefined) =>
    value === null || value === undefined ? NO_DATA_POINT_TEXT : `${value}${suffix}`
}
